import React, { useState, useEffect } from "react";
import "./VendorsignupPage.css";
import bgImage from "./../../../assets/venderlanding.webp";
import { Container, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import Feacher1 from "./../../../assets/doller_landing.png";
import Feacher2 from "./../../../assets/shop_landing.png";
import Feacher3 from "./../../../assets/bus_landing.png";
import Feacher4 from "./../../../assets/product_landing.png";
import Feacher5 from "./../../../assets/customer_landing.png";
import Feacher6 from "./../../../assets/support_landing.png";
import Brand1 from "./../../../assets/brand1.webp";
import Brand2 from "./../../../assets/brand2.webp";
import Brand3 from "./../../../assets/brand3.png";
import Brand4 from "./../../../assets/brand4.png";
import Brand5 from "./../../../assets/brand5.png";
import Brand6 from "./../../../assets/brand6.png";
import Brand7 from "./../../../assets/brand7.png";
import steps1 from "./../../../assets/steps1.webp";
import steps2 from "./../../../assets/steps2.webp";
import steps3 from "./../../../assets/steps3.webp";
import double_couts from "./../../../assets/double_couts.png";
import mobile_landing from "./../../../assets/mobile_landing.png";
import { useNavigate, useLocation } from "react-router-dom";
import OtpPage from "../../otpverification/components/OtpPage";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { fetchLogindata } from "../../login/redux/actions";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { findAccountdeletedrequest } from "../../login/util/findAccountIfDeleted";
import startsWith from "lodash.startswith";
import "react-phone-input-2/lib/style.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  EYE,
  EYE_OFF,
  PLUS_ADD,
  MINUS,
} from "../../comman/components/CommonimagePath";
import apple_ios from "../../../assets/apple.svg";
import google_play from "../../../assets/google_play.svg";
import arrow_right from "../../../assets/arrow_right_red.svg";
import { sendOtprequest } from "../../otpverification/util/sendOtp";
import ButtonPage from "../../comman/button/ButtonPage";
import PhoneInputPage from "../../comman/phoneinput/PhoneInputPage";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import { maintainCartdata } from "../../home/redux/actions";


function VendorsignupPage(props) {
  
  const [quetionSelect, setQuetionSelect] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const [page_from, setpage_from] = useState("vendor");
  const [mobileexist, setMobileexist] = useState(false);
  const [phoneinput, setPhoneinput] = useState();
  const [inputvalue, setInputvalue] = useState({
    first_name: "",
    mobile:
      location?.state?.fromlogin === true ? location?.state?.mobilenum : "",
    email: "",
    password: "",
    title: "",
    lat: "",
    lng: "",
    address: "",
    city: "",
    country: "",
    state: "",
    zip_code: "",
    country_code:
      location?.state?.fromlogin === true
        ? location?.state?.country_code
        : "90",
    country_isocode: location?.state?.fromlogin === true ? "" : "tr",
  });
  const [errors, setErrors] = useState({
    first_name: "",
    mobile: "",
    email: "",
    password: "",
    title: "",
    country_code: "",
  });
  const Steps = [
    {
      image: steps1,
      title: t("pages.parter.steps.create_account"),

    },
    {
      image: steps2,
      title: t("pages.parter.steps.list_product"),
    },
    {
      image: steps3,
      title: t("pages.parter.steps.go_live"),
    },
  ];
  const data = [
    {
      image: Feacher1,
      text: t("pages.parter.features.inventory"),
      description: t("pages.parter.features.inventory_desc"),
    },
    {
      image: Feacher2,
      text: t("pages.parter.features.market"),
      description: t("pages.parter.features.market_desc"),
    },
    {
      image: Feacher3,
      text: t("pages.parter.features.deliver"),
      description: t("pages.parter.features.deliver_desc"),
    },
    {
      image: Feacher4,
      text: t("pages.parter.features.product"),
      description: t("pages.parter.features.product_desc"),
    },
    {
      image: Feacher5,
      text: t("pages.parter.features.customers"),
      description: t("pages.parter.features.customers_desc"),
    },
    {
      image: Feacher6,
      text: t("pages.parter.features.support"),
      description: t("pages.parter.features.support_desc"),
    },
  ];

  const quetions = [
    {
      text: t("pages.parter.quetions.q1"),
      description: "It only takes a few clicks to become a Girne partner. Simply sign up, enter your business information, and add your products, and your shop is ready to accept online orders.",
      descriptionTr: "Girne iş ortağı olmak için sadece birkaç tık yeterlidir. Kaydolun, işletme bilgilerinizi girin ve ürünlerinizi ekleyin; mağazanız çevrimiçi siparişleri kabul etmeye hazır."
    },
    {
      text: t("pages.parter.quetions.q2"),
      description: "It is completely free to create and run an online shop with Girne.",
      descriptionTr: "Girne ile bir online mağaza oluşturmak ve işletmek tamamen ücretsizdir."
    },
  ];

  const brandList = [
    {
      title: "brand1",
      image: Brand1,
    },
    {
      title: "brand2",
      image: Brand2,
    },
    {
      title: "brand3",
      image: Brand3,
    },
    {
      title: "brand4",
      image: Brand4,
    },
    {
      title: "brand5",
      image: Brand5,
    },
    {
      title: "brand1",
      image: Brand1,
    },
  ];

  const reviewList = [
    {
      review: "I was blown away by how quick and easy it was to create my online store with the Girne App. The platform is packed with features that would usually cost a fortune elsewhere, and the fact that it's free is amazing. Thank you for helping me take my business to the next level",
      reviewTr: "Girne Uygulaması ile çevrimiçi mağazamı oluşturmanın ne kadar hızlı ve kolay olduğu beni çok şaşırttı. Platform, başka bir yerde genellikle bir servete mal olacak özelliklerle doludur ve ücretsiz olması şaşırtıcıdır. İşimi bir sonraki seviyeye taşımama yardım ettiğiniz için teşekkür ederim!",
      customerName: "Ali Taner"
    },
    {
      review: "Creating my online store with this website was a breeze! The platform is user-friendly and offers all the necessary tools to get started. The best part? It's completely free! I highly recommend this website to any store owner looking to expand their business online.",
      reviewTr: "Bu web sitesiyle çevrimiçi mağazamı oluşturmak çocuk oyuncağı! Platform kullanıcı dostu ve başlamak için gerekli tüm araçları sunuyor. En iyi yanı mı? Tamamen ücretsiz! Bu web sitesini işlerini çevrimiçi büyütmek isteyen tüm mağaza sahiplerine şiddetle tavsiye ediyorum.",
      customerName: "Can Baykal"
    },
    {
      review: "As a small business owner, I never imagined I'd be able to afford to open an online store. That's why I was so thrilled to discover the Girne App. It is not only free, but it also includes all of the features I require to run a successful online store. I can't thank the team enough for developing such an incredible platform.",
      reviewTr: "Bir küçük işletme sahibi olarak, bir çevrimiçi mağaza açabileceğimi asla hayal edemezdim. Bu yüzden Girne Uygulamasını keşfetmekten çok heyecanlandım. Yalnızca ücretsiz değil, aynı zamanda başarılı bir çevrimiçi mağaza işletmek için ihtiyaç duyduğum tüm özellikleri içeriyor. Böylesine inanılmaz bir platform geliştirdikleri için ekibe ne kadar teşekkür etsem azdır.",
      customerName: "Fatma Türkmen"
    }
  ]

  const passRegex =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\w\W]){1,})(?!.*\s).{8,}$/;
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  // const nameRegex = /^[A-Za-z ığüşöçİĞÜŞÖÇ]+$/;
  const [errorState, seterrorState] = useState(false);
  const [showotp, setShowotp] = useState(false);
  const navigate = useNavigate();
  const [passwordState, setPasswordState] = useState(false);

  useEffect(() => {
    (async () => callCountrycodelist())();
    // eslint-disable-next-line
  }, [props?.language]);

  const callCountrycodelist = async () => {
    if (location?.state?.fromlogin === true) {
      toast.error(t("pages.signup.No accound found please sign up"));
      setPhoneinput(location?.state?.country_code + location?.state?.mobilenum);
    }
    props?.fetchHeaderContent(t("pages.meta.partner.title"), t("pages.meta.partner.description"), "");
  };

  const inputChange = (e) => {
    setInputvalue({
      ...inputvalue,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validation = () => {
    let value = true;
    if (!inputvalue.email.match(emailRegex)) {
      errors.email = "pages.parter.email_valid";
      value = false;
    }
    // if (!nameRegex.test(inputvalue.first_name)) {
    //   errors.first_name = "pages.signup.fullname_validation";
    //   value = false;
    // }
    if (inputvalue.email === "") {
      value = false;
      errors.email = "pages.parter.email_warn";
    }
    if (inputvalue.mobile === "") {
      value = false;
      errors.mobile = "pages.parter.mobile_warn";
    }
    if (errors.country_code !== "") {
      errors.mobile = "";
      value = false;
    }
    if (inputvalue.title === "") {
      value = false;
      errors.title = "pages.parter.busi_name_warn";
    }
    if (!inputvalue.password.match(passRegex)) {
      value = false;
      errors.password = "pages.parter.password_valid";
    }
    if (inputvalue.password === "") {
      value = false;
      errors.password = "pages.parter.password_warn";
    }
    if (inputvalue.first_name === "") {
      value = false;
      errors.first_name = "pages.parter.fullname_warn";
    }
    setErrors({
      ...errors,
      first_name: errors.first_name,
      mobile: errors.mobile,
      email: errors.email,
      password: errors.password,
      title: errors.title,
    });
    return value;
  };

  const callSignup = async (e) => {
    e.preventDefault();
    if (validation()) {
      let findAccountdeletedresponse = await findAccountdeletedrequest(
        inputvalue.mobile,
        inputvalue.country_code
      );
      if (findAccountdeletedresponse?.status === 200) {
        toast.error(t("pages.Your account deleted please contact to admin"));
      } else if (findAccountdeletedresponse?.status === 404) {
        // if (location?.state?.fromlogin === true) {
        //   forVendorsignup();
        // } else {
          getLocationInformation();
          seterrorState(false);
          let sendOtpresponse = await sendOtprequest(
            inputvalue.mobile,
            inputvalue.country_code,
            props?.language?.toLowerCase()
          );
          if (
            sendOtpresponse?.status === 200 ||
            sendOtpresponse?.status === 201
          ) {
            let result = await sendOtpresponse.json();
            if (result?.data?.mobile_already_exist === "yes") {
              setMobileexist(true);
            } else {
              setMobileexist(false);
            }
            setShowotp(true);
          } else if (sendOtpresponse?.status === 400) {
            let responce = await sendOtpresponse.json();
            toast.error(responce?.errors);
            setShowotp(false);
          }
        // }
      }
    } else {
      seterrorState(true);
    }
  };

  const getLocationInformation = () => {
    setInputvalue({
      ...inputvalue,
      lat: props.currentLocation.lat,
      lng: props.currentLocation.lng,
      address: props.currentLocation.address,
      city: props.currentLocation.city,
      country: props.currentLocation.country,
      zip_code: props.currentLocation.zip_code,
    });
  };

  // const forVendorsignup = async () => {
  //   let registerInput = {
  //     title: inputvalue.title,
  //     address: props.currentLocation.address,
  //     city: props.currentLocation.city,
  //     country: props.currentLocation.country,
  //     zip_code: props.currentLocation.zip_cod,
  //     first_name: inputvalue.first_name,
  //     mobile: inputvalue.mobile,
  //     type: "vendor",
  //     email: inputvalue.email,
  //     password: inputvalue.password,
  //     lat: props.currentLocation.lat,
  //     lng: props.currentLocation.lng,
  //     service_id: null,
  //     image: "",
  //     images: "",
  //     store_type: "goods",
  //     lang: props?.language?.toLowerCase(),
  //     country_code: inputvalue.country_code,
  //   };
  //   let registerResponse = await registerrequest(registerInput);
  //   if (registerResponse?.status === 200) {
  //     // Navigate to business setup page for edit the current store
  //     let loginData = await registerResponse.json();
  //     let getIp = await getIpaddress();
  //     props.fetchLogindata(loginData.data, getIp?.ip);
  //     navigate(`/vendor/${loginData?.data?.store_id}`);
  //     await updateCartVendorsignup(loginData);
  //     await updateSendnotification(loginData);
  //   } else if (registerResponse.status === 400) {
  //     let getValue = await registerResponse.json();
  //     showServererror(getValue);
  //   } else if (registerResponse.status === 500) {
  //     toast.error(t("pages.signup.email_exist"));
  //   }
  // };

  // const updateSendnotification = async (loginData) => {
  //   let geturl = SEND_NOTIFICATION + `?type=${"store"}&id=${loginData?.data?.store_id}`
  //   await postRequestcall(geturl, loginData?.data?.token?.access_token, "");
  // }

  // const updateCartVendorsignup = async (loginData) => {
  //   if (props?.cartdata?.length > 0) {
  //     let object = {};
  //     let productlist = [];
  //     props?.cartdata?.forEach((product) => {
  //       object = {
  //         store_id: product?.store_id,
  //         product_id: product?.product_id,
  //         variation_id: product?.variation_id,
  //         quantity: product?.quantity,
  //         id: product?.id,
  //       };
  //       productlist.push(object);
  //     });
  //     let data = {
  //       cartdata: productlist,
  //     };
  //     const updateCartresponse = await updateCartrequest(
  //       loginData?.data?.token?.access_token,
  //       data,
  //       props?.language?.toLowerCase()
  //     );
  //     if (updateCartresponse.status === 400) {
  //       let getErrormsg = await updateCartresponse.json();
  //       toast.error(getErrormsg?.errors);
  //       props.maintainCartdata([], {});
  //     }
  //   } else {
  //   }
  // };

  // const showServererror = (getValue) => {
  //   if (getValue?.errors?.mobile && getValue?.errors?.email) {
  //     toast.error(
  //       t(
  //         "pages.Your mobile and email already been taken please sign up with another email and mobile"
  //       )
  //     );
  //   } else if (getValue?.errors?.mobile) {
  //     toast.error(t("pages.please sign up with another mobile"));
  //   } else if (getValue?.errors?.email) {
  //     toast.error(t("pages.please sign up with another email"));
  //   }
  // };

  const redirectTologin = () => {
    navigate("/login");
  };

  const countryChange = (value, data) => {
    if (value !== "") {
      let getValue =
        startsWith(value, data?.dialCode) || startsWith(data?.dialCode, value);
      if (getValue === false) {
        setErrors({
          ...errors,
          mobile: "",
          country_code: "pages.login.country_code_valid",
        });
      } else {
        setErrors({
          ...errors,
          mobile: "",
          country_code: "",
        });
      }
      setPhoneinput(value);
      let phonecode = { rawPhone: value.slice(data.dialCode.length) };
      setInputvalue({
        ...inputvalue,
        mobile: phonecode?.rawPhone?.toString(),
        country_code: data?.dialCode.toString(),
        country_isocode: data?.countryCode,
      });
    } else {
    }
  };

  const storeButton = (image, subtitle, heading) => {
    return (
      <>
        <img src={image} height="25" width="25" alt="images"></img>
        <div className="cols">
          {props?.language === "Tr" ? (
            <>
              <h5 className="titles">
                {t(heading)}
              </h5>
              <span className="download">
                {t(subtitle)}
              </span>
            </>
          ) : (
            <>
              <span className="download">
                {t(subtitle)}
              </span>
              <h5 className="titles">
                {t(heading)}
              </h5>
            </>
          )}
        </div>
      </>
    )
  }

  return (
    <>
      <div className="vendor_signup">
        <div className="signups">
          <div
            style={{ backgroundImage: `url('${bgImage}')` }}
            alt={""}
            className={errorState ? "bg-signups errors" : "bg-signups "}
          >
            <Container className="pt-10 container-lg">
              <Row className="Signup">
                <div className="col-6">
                  <h5 className="titles-h5">
                    {t("pages.parter.caption1")}
                    {t("pages.parter.caption2")}
                    {t("pages.parter.caption3")}
                  </h5>
                </div>
                <div className="col-6 signup-card">
                  <div className="card">
                    {showotp ? (
                      <OtpPage
                        inputvalue={inputvalue}
                        showotp={showotp}
                        setShowotp={setShowotp}
                        page_from={page_from}
                        setpage_from={setpage_from}
                        setMobileexist={setMobileexist}
                        mobileexist={mobileexist}
                      ></OtpPage>
                    ) : (
                      <div className="card-body">
                        <h5 className="header-title">
                          {t("pages.parter.title")}
                        </h5>
                        <p className="title-secound">
                          {t("pages.parter.description")}
                        </p>
                        <Form className="forms" onSubmit={(e) => callSignup(e)}>
                          <Row>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <FormgroupPage
                                label={''}
                                onChange={inputChange}
                                value={inputvalue.first_name}
                                name={"first_name"}
                                placeholder={t("pages.parter.fullname")}
                                type="text"
                                error={t(errors.first_name)}
                                require={false}
                              />
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <div>
                                <PhoneInputPage
                                  country={inputvalue.country_isocode}
                                  value={phoneinput}
                                  enableSearch={true}
                                  className={"countrylist vendorsign"}
                                  onChange={countryChange}
                                />
                                <div className="text-danger">
                                  {t(errors.country_code)}
                                  {t(errors.mobile)}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <FormgroupPage
                                label={''}
                                onChange={inputChange}
                                value={inputvalue.email}
                                name={"email"}
                                placeholder={t("pages.parter.email")}
                                type={"text"}
                                error={t(errors.email)}
                                require={false}
                              />
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <InputGroup>
                                <FormControl
                                  onChange={inputChange}
                                  value={inputvalue.password}
                                  name={"password"}
                                  className="sda"
                                  placeholder={t("pages.parter.password")}
                                  type={passwordState ? "text" : "password"}
                                />
                                <InputGroup.Text
                                  onClick={() =>
                                    setPasswordState(!passwordState)
                                  }
                                >
                                  <img
                                    src={passwordState ? EYE : EYE_OFF}
                                    height="25"
                                    width="25"
                                    alt="open"
                                  />
                                </InputGroup.Text>
                              </InputGroup>
                              <span className="text-danger">
                                {t(errors.password)}
                              </span>
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <FormgroupPage
                                label={''}
                                onChange={inputChange}
                                value={inputvalue.title}
                                name={"title"}
                                placeholder={t("pages.parter.busi_name")}
                                type={"text"}
                                error={t(errors.title)}
                                require={false}
                              />
                            </div>
                            <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <ButtonPage
                                Text={t("pages.parter.submit")}
                                className="button-submit w-100"
                                type="submit"
                              />
                            </div>
                            <div className="text-center">
                              <label>
                                {t("pages.parter.have_account")}{" "}
                                <span
                                  className="primary-text"
                                  onClick={() => redirectTologin()}
                                >
                                  {t("pages.parter.login")}
                                </span>
                              </label>
                            </div>
                          </Row>
                        </Form>
                      </div>
                    )}
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </div>
        <div className="feacher-container">
          <div className="container">
            <h3 className="text-5">{t("pages.parter.features.title")}</h3>
            <p className="text-p secound-text">
              {t("pages.parter.features.description")}
            </p>
            <Row className="mt-5 feacher_list">
              {data.map((item, index) => (
                <div
                  key={index.toString()}
                  className="mb-5 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                >
                  <div className={`feacher-${index + 1}`}>
                    <LazyLoadImage
                      className="feacher-image"
                      src={item.image}
                      alt={"."}
                    />
                    <h5>{item.text}</h5>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </Row>
          </div>
        </div>
        <div className="brands">
          <div className="text-center  col-12">
            <h5 className="text-5  pb-5">{t("pages.parter.favorite")}</h5>
            <Row>
              <div className="brand_list1">
                {brandList.map((item, index) => (
                  <LazyLoadImage
                    key={index?.toString()}
                    src={item.image}
                    alt={"."}
                    className={item.title}
                  />
                ))}
              </div>
              <div className="brand_list2">
                <LazyLoadImage src={Brand6} alt={"."} className={"brand6"} />
                <LazyLoadImage src={Brand7} alt={"."} className={"brand7"} />
              </div>
            </Row>
          </div>
        </div>
        <div className="steps">
          <div className="text-center">
            <h3 className="text-5">{t("pages.parter.steps.title")}</h3>
            <Container className={"container-lg"}>
              <Row className="steps-inner">
                {Steps.map((item, index) => (
                  <div className="col steps_arrows" key={index?.toString()}>
                    <div className="steps_lists">
                      <LazyLoadImage
                        className="steps_img"
                        src={item.image}
                        alt={""}
                      />
                      <h5>{item.title}</h5>
                      <p>{item.location}</p>
                    </div>
                    {index === Steps.length - 1 ? null : (
                      <img
                        src={arrow_right}
                        alt="next"
                        height="25"
                        width="25"
                      ></img>
                    )}
                  </div>
                ))}
              </Row>
            </Container>
          </div>
        </div>
        <div className="swipper-conatiners testimonials">
          <Container className={"container-lg"}>
            <p className="primary-text">{t("pages.parter.vendors.subtitle")}</p>
            <h4>{t("pages.parter.vendors.title")}</h4>
            <Row>
              {reviewList.map((item) => (
                <div className="col-4">
                  <div className="card">
                    <div className="card-body">
                      <LazyLoadImage alt="" src={double_couts} />
                      <p className="description">
                        {props?.language === "Tr" ? item?.reviewTr : item?.review}
                      </p>
                      <h5 className="header-title">- {item?.customerName}</h5>
                      <label className="locations">Cyprus</label>
                    </div>
                  </div>
                </div>
              ))
              }
            </Row>
          </Container>
        </div>
        <div className="quetions ">
          <div className="text-center">
            <h5 className="text-5 pt-3 pb-3">
              {t("pages.parter.quetions.title")}.
            </h5>
          </div>
          <Container className={"container-lg"}>
            <Row className="step_row">
              {quetions.map((item, index) => (
                <div className="quetionslist" key={index?.toString()}>
                  <div
                    onClick={() =>
                      index === quetionSelect
                        ? setQuetionSelect("")
                        : setQuetionSelect(index)
                    }
                    className="collaps"
                  >
                    <h5>{item.text}</h5>
                    <img
                      src={quetionSelect === index ? MINUS : PLUS_ADD}
                      height="25"
                      width="25"
                      alt="plus"
                    ></img>
                  </div>
                  <div
                    className={
                      quetionSelect === index
                        ? "collaps-bottom show"
                        : "collaps-bottom"
                    }
                  >
                    <p>{props?.language === "Tr" ? item?.descriptionTr : item?.description}</p>
                  </div>
                </div>
              ))}
            </Row>
          </Container>
        </div>
        <div className="official">
          <div className="center">
            <h3 className="text-5 text-white">
              {t("pages.parter.playstore.title")}
            </h3>
            <p className="p-1 text-white">
              {t("pages.parter.playstore.subtitle")}
            </p>
            <div className="button_div">
              <button className="ios_btn" onClick={() => window.open("https://apps.apple.com/in/app/girne/id6444398214", "_blank")}>
                {storeButton(apple_ios, "pages.parter.playstore.appstore_subtitle", "pages.home.appinfo.btn_2.title2")}
              </button>
              <button className="ios_btn" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.girne", "_blank")}>
                {storeButton(google_play, "pages.parter.playstore.play_subtitle", "pages.parter.playstore.play_title")}
              </button>
            </div>
            <label className="caption">
              {t("pages.parter.playstore.subtitle2")}
            </label>
            <div className="mobile-div">
              <LazyLoadImage
                src={mobile_landing}
                className={"mobile-images"}
                alt={""}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  currentLocation: state?.home?.currentLocation,
  cartdata: state?.home?.cartdata,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchLogindata, fetchHeaderContent,maintainCartdata })(
  VendorsignupPage
);
